
export const betterImage = (url?: string, height: number = 200) => {
  if (!url) return '';
  const _url = new URL(url);
  return `https://i1.wp.com/dynamic-assets.imageg.top${_url.pathname}?quality=99&h=${height}`
}